import { onMounted, onUnmounted } from 'vue';
import { infuse } from '../../../ioc-config';

export const useDealerLocatorAem = () => {
  const { componentTag } = infuse('config');
  // Get component where it has to be inserted
  const pageComponent = document.querySelector(componentTag)?.shadowRoot; // srp, pdp, pcp
  // Selector to the all DL styles
  const dlStylesSelector = 'link[href*=one-dlc]';

  // Create mutation observer to get all dynamically inserted styles
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(() => {
      // Create an array of already existing styles to avoid duplicates
      const existingStyles: string[] = Array.from(
        pageComponent?.querySelectorAll<HTMLLinkElement>(dlStylesSelector) || [],
      ).map((linkEl) => linkEl.href);

      // Get all DL styles / link elements
      document.head.querySelectorAll<HTMLLinkElement>(dlStylesSelector).forEach((linkEl) => {
        // Check if they aren't yet in our component
        if (!existingStyles.includes(linkEl.href)) {
          // Clone node before appending it to leave those styles also in head:
          // we can't know if it was our DL initialization
          pageComponent?.append(linkEl.cloneNode(true));
        }
      });
    });
  });

  onMounted(() => {
    observer.observe(document.head, { attributes: false, childList: true, characterData: false });
  });

  onUnmounted(() => {
    if (observer) {
      observer.disconnect();
    }
  });
};
